"use client"

import React from "react"
import phoneImage from "../../assets/Celular-mano-1.png"
import estadisImage from "../../assets/panel.png"
import miniImpresoraImage from "../../assets/printer.webp"
import membresiasIcon from "../../assets/CarroDorado.png"

// Helper function to get image dimensions
const getImageDimensions = (imageSrc) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
        aspectRatio: img.width / img.height,
      })
    }
    img.src = imageSrc
    img.crossOrigin = "anonymous" // Prevent CORS issues
  })
}

const ServiceItem = ({ title, description, features, image, reverse }) => {
  const [imageLoaded, setImageLoaded] = React.useState(false)
  const [imageDimensions, setImageDimensions] = React.useState(null)

  React.useEffect(() => {
    if (image) {
      getImageDimensions(image).then((dimensions) => {
        setImageDimensions(dimensions)
      })
    }
  }, [image])

  const handleImageLoad = () => {
    setImageLoaded(true)
  }

  return (
    <div className={`service-item-ini ${reverse ? "reverse-ini" : ""}`}>
      <div className="service-image-container-ini">
        <div className={`service-image-wrapper-ini ${!imageLoaded ? "image-loading" : ""}`}>
          <img
            src={image || "/placeholder.svg"}
            alt={title}
            className="service-image-ini"
            loading="lazy" // Lazy load images
            decoding="async" // Async decoding for better performance
            onLoad={handleImageLoad}
            style={{
              // Preserve original aspect ratio if available
              aspectRatio: imageDimensions ? `${imageDimensions.width} / ${imageDimensions.height}` : "16 / 9",
              // Use object-position to center the image without cropping important parts
              objectPosition: "center",
            }}
          />
        </div>
        <div className={`service-image-bg-ini ${reverse ? "right-ini" : ""}`}></div>
      </div>
      <div className="service-content-ini">
        <h3 className="service-title-ini">{title}</h3>
        <p className="service-description-ini">{description}</p>
        <ul className="service-features-ini">
          {features.map((feature, index) => (
            <li key={index}>
              <span className="feature-dot-ini"></span> {feature}
            </li>
          ))}
        </ul>
        <button className="service-button-ini">Más información</button>
      </div>
    </div>
  )
}

export default function ServiciosSection() {
  const services = [
    {
      title: "Software de gestión",
      description: "Plataforma integral para el control de entradas, salidas, pagos y reportes de tu parqueadero.",
      features: [
        "Dashboard con métricas en tiempo real",
        "Control de tarifas flexibles",
        "Gestión de Tickets",
        "Reportes financieros detallados",
        "Gestion de Disponibilidad",
      ],
      image: estadisImage,
    },
    {
      title: "Hardware especializado",
      description: "Equipos diseñados específicamente para optimizar la operación de tu parqueadero.",
      features: [
        "Impresoras térmicas de alta velocidad",
        "Lectores de códigos QR",
        "Cámaras de reconocimiento de placas",
      ],
      image: miniImpresoraImage,
      reverse: true,
    },
    {
      title: "Aplicación móvil",
      description: "App para administradores y clientes que facilita la gestión y uso del parqueadero.",
      features: [
        "Control remoto de la operación",
        "Impresion de Ticket",
        "Monitoreo de Registros",
        "Reporte de recaudaciones",
        "Historial de uso para clientes",
      ],
      image: phoneImage,
    },
  ]

  return (
    <section className="services-section-ini">
      <div className="container-ini">
        <div className="section-header-ini">
          <h2 className="section-title-ini">Soluciones integrales para tu parqueadero</h2>
          <p className="section-description-ini">
            Ofrecemos un ecosistema completo de productos y servicios diseñados específicamente para la gestión de
            estacionamientos.
          </p>
        </div>
        <div className="services-list-ini">
          {services.map((service, index) => (
            <ServiceItem
              key={index}
              title={service.title}
              description={service.description}
              features={service.features}
              image={service.image}
              reverse={service.reverse}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
